/**
 * Zorgt voor het kunnen draggen van de pupils
 * id = pupil_index
 *
 * @history
 * 23 november 2022
 * Basis implementatie
 *
 */

import React from 'react';
import {useDraggable} from '@dnd-kit/core';

export function DraggablePupil(props) {
    const {attributes, listeners, setNodeRef, transform} = useDraggable({
        id: props.id,
        data:
            {
                pupil_index:props.pupil_index
            }
    });
    const style = transform ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,

    } : undefined;


    return (
        <button ref={setNodeRef} style={style} {...listeners} {...attributes} className={"draggable_pupil_wrapper"} id={props.id}>
            {props.children}
        </button>
    );
}
